import { useQuery } from '@tanstack/react-query';
import { get, api } from '../../lib/api';

export const useBoards = () => {
  const { data = { boards: [] }, refetch, isLoading, fetchStatus } = useQuery(
    ['boards'],
    () => get('/api/boards'),
    { enabled: false },
  );

  return {
    boards: data.boards || [],
    fetchBoards: refetch,
    isIdle: fetchStatus === 'idle',
    isLoading,
  };
};

export const useOrganizations = () => {
  const { data = [] } = useQuery(['organizations'], () =>
    get('/api/v1/organizations'),
  );

  const organizations = data.map(organization => ({
    value: organization[1],
    label: organization[0],
  }));

  return {
    organizations,
  };
};

export const useBoardTypes = () => {
  const { data = [] } = useQuery(['demo_customer_statuses'], () =>
    get('/api/v1/demo_customer_statuses'),
  );

  const boardTypes = data.map(boardType => ({
    value: boardType[1],
    label: boardType[0],
  }));

  return {
    boardTypes,
  };
};

export const useCampaignTemplates = () => {
  const { data = [] } = useQuery(['campaignTemplates'], () =>
    get('/api/v1/campaign_templates'),
  );

  const campaigns = data.map(template => ({
    value: template.campaign.uuid,
    label: template.campaign.name,
  }));

  return {
    campaigns,
  };
};

export const createBoard = ({ data }) => {
  return api({
    method: 'post',
    url: '/boards',
    data,
  });
};
